<script setup lang="ts">
import AltraIcon from "~/components/AltraIcon.vue";

</script>

<template>
<div class="a-checkpoint">
  <div class="sec-icon">
    <div class="inner">
      <slot>
        <AltraIcon />
      </slot>
    </div>
  </div>
</div>
</template>

<style lang="scss" scoped>
.a-checkpoint {
  width: 100px;
  height: 100px;
  .sec-icon {
    width: 100px;
    height: 100px;
    border-radius: 100%;
    background: white;
    .inner {
      width: 100%;
      height: 100%;
      border-radius: 100%;
      /* box-shadow: inset 0 0 0 1px var(--base-500); */

      /* filter: blur(1px); */

      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 40%;
        height: auto;
        object-fit: contain;
      }

      svg {
        width: 50px;
        height: 50px;
        /* &.isolve-icon { */
        /*   width: 40px; */
        /*   height: 40px; */
        /* } */
      }
    }
  }
}
</style>